import React, {useEffect, useState} from 'react'
import SecretKeyTextField from "../SecretKeyTextField"
import {TogetherJson} from "../../../api/json/IntegrationJson"
import {IntegrationSettingsFormProps} from "./IntegrationSettingsFormProps"
import {ModelPlatform} from "../../../api/enum/ModelPlatform"

interface TogetherSettingsFormProps extends IntegrationSettingsFormProps {
    together: TogetherJson | null
}

function TogetherSettingsForm({together, onChange}: TogetherSettingsFormProps) {
    const [secretKey, setSecretKey] = useState<string>(together?.secretKey ?? "")
    const [isValidSecretKey, setIsValidSecretKey] = useState(true)

    useEffect(() => {
        if (secretKey === "") return

        // Loose guard against obvious typos. Together's exact key format isn't pinned down here,
        // so we avoid rejecting otherwise-valid keys and let the API be the source of truth.
        const isValid = secretKey.length >= 40
        setIsValidSecretKey(isValid)

        const unsavedChanges = !together || (secretKey !== "" && secretKey !== together.secretKey)

        onChange({
            platform: ModelPlatform.TOGETHER,
            id: together?.id ?? null,
            secretKey: secretKey,
        }, isValid, unsavedChanges)
    }, [secretKey])

    return (
        <SecretKeyTextField label="API key"
                            value={secretKey}
                            setValue={setSecretKey}
                            valid={isValidSecretKey}
        />
    )
}

export default TogetherSettingsForm
